import { createReducer, on } from '@ngrx/store';
import { LoadStatus } from 'src/app/core/enums/load-status.enum';
import { StatusRule } from '../../../../../admin/data-access/models/status-rules';
import {
  loadStatusRulesFailure,
  loadStatusRulesSuccess,
} from '../actions/status-rule.actions';

export const statusRuleFeatureKey = 'statusRule';

export interface StatusRuleState {
  statusRules: StatusRule[];
  _ui: {
    status: LoadStatus;
  };
}

export const initialState: StatusRuleState = {
  statusRules: [],
  _ui: {
    status: LoadStatus.NOT_LOADED,
  },
};

export const statusRulesReducer = createReducer(
  initialState,
  on(loadStatusRulesSuccess, (state, action): StatusRuleState => {
    return {
      ...state,
      statusRules: action.statusRules,
      _ui: { status: LoadStatus.LOADED },
    };
  }),
  on(loadStatusRulesFailure, (state): StatusRuleState => {
    return { ...state, _ui: { status: LoadStatus.NOT_LOADED } };
  })
);
